<div [ngClass]="wrapperCssClasses" >
  @if (displayOnRight) {
    <i [ngClass]="iconCssClasses"></i><span [ngClass]="textCssClasses">&nbsp;{{displayMessage}}</span>
  }

  @if (!displayOnRight) {
    <span [ngClass]="textCssClasses">{{displayMessage}} </span> <i [ngClass]="iconCssClasses"></i>
  }
</div>